var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rows-input-container"},[_vm._t("default"),_c('el-input-number',{attrs:{"min":_vm.min,"max":_vm.max,"label":""},on:{"change":_vm.handleChange},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }